<template>
  <el-header class="navbar">
    <div class="nav-container">
      <div class="logo">
        <img src="../assets/tarom/logo.png" alt="Logo">
      </div>
      <el-menu
        :default-active="activeIndex"
        mode="horizontal"
        @select="handleSelect"
        background-color="#fff"
        text-color="#333"
        active-text-color="#409EFF">
        <!-- <el-menu-item index="1">主页</el-menu-item> -->
        <!-- <el-menu-item index="2">熱款推荐</el-menu-item>
        <el-menu-item index="3">商品分類</el-menu-item>
        <el-menu-item index="4">如何購買</el-menu-item>
        <el-menu-item index="5">聯絡我們</el-menu-item> -->
      </el-menu>
      <div class="nav-right">
        <!-- <el-badge :value="cartCount" class="cart-badge">
          <el-button type="text" icon="el-icon-shopping-cart-2">购物车</el-button>
        </el-badge> -->
      </div>
    </div>
  </el-header>
</template>

<script>
export default {
  name: 'Navbar',
  data() {
    return {
      activeIndex: '1',
      cartCount: 2
    }
  },
  methods: {
    handleSelect(key) {
      this.activeIndex = key
    }
  }
}
</script>

<style scoped>
.navbar {
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 1000;
  background: #fff;
}

.nav-container {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.logo img {
  height: 40px;
  margin: 10px 0;
}

.nav-right {
  margin-left: 20px;
}

.cart-badge {
  margin-top: 10px;
}
</style>